<div
    class="agpr-networkRadio"
>
    <span> {{ heading | localize }}</span>
    <div
        class="agpr-networkRadio-row"
        role="radiogroup"
        [attr.aria-label]="ariaLabel | localize"
    >
        @for (network of networkOptions; track network.type) {
            @if (!network.disabled) {
                <agpr-radio
                    [id]="id + '.' + network.type"
                    [value]="network"
                    [name]="id + '_network_options'"
                    [(ngModel)]="selectedSocialNetwork"
                    (ngModelChange)="selectedNetwork.emit(selectedSocialNetwork.type)"
                    [style]="radioTypesEnum.socialNetworks"
                    [iconImageUrl]="network.iconImageUrl"
                    [disabled]="network.disabled"
                    [iconTooltip]="network.tooltip"
                    [iconImageAltText]="network.tooltip"
                ></agpr-radio>
            }
        }
    </div>
</div>
